import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Gate for signed-in pages: anyone else is sent to the sign-in screen.
export default function ProtectedRoute({ children }) {
  const auth = useAuth();
  const here = useLocation();
  if (auth.isAuthorized) return children;
  return <Navigate to="/login" replace state={{ from: here.pathname + here.search }} />;
}
